import React from "react";

const SpeakersSection = () => {
  const speakers = [
    {
      name: "Dr. Anika Williams",
      title: "Energy Policy Advisor, CoreGas",
      img: "assets/images/speakers/1.png",
    },
    {
      name: "Jonathan Blake",
      title: "VP Strategy, CoreGas Inc.",
      img: "assets/images/speakers/2.png",
    },
    {
      name: "Ahmed Khan, Director",
      title: "Global Oil Solutions",
      img: "assets/images/speakers/3.png",
    },
    {
      name: "Thomas Everett",
      title: "Partner, GreenEdge Capital",
      img: "assets/images/speakers/4.png",
    },
  ];

  return (
    <section className="speakers py-5">
      <div className="container">
        <div className="speaker-inner">
          {/* Section Title */}
          <div className="speaker-title text-center p-2 mb-4">
            <div className="row align-items-center">
              <div className="col-lg-6 mx-auto">
                <div className="title-content text-center mb-3">
                  <p className="mb-1 pink">EVENT SPEAKERS</p>
                  <h2 className="mb-1">
                    MEET OUR <span className="pink">SPEAKERS</span>
                  </h2>
              
                </div>
              </div>
            </div>
          </div>

          {/* Speaker List */}
          <div className="sepaker-list text-center text-white">
            <div className="row g-3">
              {speakers.map((speaker, i) => (
                <div key={i} className="col-lg-3 col-md-6 col-sm-6 speaker-col">
                  <div className="speaker-box position-relative overflow-hidden rounded shadow-sm">
                    <img
                      className="speaker-image"
                      src={speaker.img}
                      alt={speaker.name}
                    />
                    <div className="box-content position-absolute bottom-0 z-1 w-100 text-center px-2">
                     <h6 className="speaker-title d-block text-white pb-1 mb-0">
  {speaker.name}
</h6>

                      <span className="speaker-post d-block pb-2 small">
                        {speaker.title}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Styling */}
      <style>{`
        .speaker-image {
          aspect-ratio: 2/2; 
          object-fit: cover;
          width: 100%;
          border-radius: 12px;
          transition: transform 0.3s ease;
          max-height: 350px;
        }
        .speaker-box:hover .speaker-image {
          transform: scale(1.05);
        }
        .box-content {
          background: rgba(0, 0, 0, 0.5);
          padding: 8px;
        }

        /* Desktop (4 per row) */
        @media (min-width: 992px) {
          .speaker-col {
            flex: 0 0 25%;
            max-width: 25%;
          }
          .speaker-image {
            max-height: 320px;
          }
        }

        /* Tablet (2 per row) */
        @media (min-width: 576px) and (max-width: 991px) {
          .speaker-col {
            flex: 0 0 50%;
            max-width: 50%;
          }
        }

        /* Mobile (2 per row, smaller height) */
        @media (max-width: 575px) {
          .speaker-col {
            flex: 0 0 50%;
            max-width: 50%;
          }
          .speaker-image {
            aspect-ratio: 3/4;
            max-height: 220px;
          }
          .speaker-title {
            font-size: 0.85rem;
          }
          .speaker-post {
            font-size: 0.7rem;
          }
        }
      `}</style>
    </section>
  );
};

export default SpeakersSection;
